import React from "react";
import "./App.css";
import Navbar from "./components/Navbar";
import Ticker from "./components/Ticker";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Homas from "./components/Homas";
import Zodiac from "./components/Zodiac";
import WhyChoose from "./components/WhyChoose";
import Counters from "./components/Counters";
import Reviews from "./components/Reviews";
import ConsultForm from "./components/ConsultForm";
import FAQ from "./components/FAQ";
import CTABanner from "./components/CTABanner";
import Location from "./components/Location";
import Footer from "./components/Footer";
import FloatingButtons from "./components/FloatingButtons";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Ticker />
      <Hero />
      <About />
      <Services />
      <Homas />
      <Zodiac />
      <WhyChoose />
      <Counters />
      <Reviews />
      <ConsultForm />
      <FAQ />
      <CTABanner />
      <Location />
      <Footer />
      <FloatingButtons />
    </div>
  );
}

export default App;
